// Masks secrets before an event leaves for Sentry: the issue title, extras, breadcrumbs
// and span descriptions all carry raw URLs (e.g. the WP preview token in ?token=).

export const FILTERED = '[Filtered]'

const SECRET_QUERY_PARAM = /([?&](?:token|secret|password|passwd|api[_-]?key|apikey|key|access[_-]?token|auth|signature|sig)=)[^&#\s"'<>]*/gi

const SECRET_KEY = /^(authorization|proxy-authorization|cookie|set-cookie|x-guide-proxy-key|x-api-key|password|secret|token)$/i

export function scrubString(value: string): string {
    return value.replace(SECRET_QUERY_PARAM, `$1${FILTERED}`)
}

function scrubValue(value: unknown): unknown {
    if (typeof value === 'string') return scrubString(value)
    if (Array.isArray(value)) return value.map(scrubValue)
    if (value === null || typeof value !== 'object') return value

    return Object.fromEntries(
        Object.entries(value).map(([key, entry]) => [key, SECRET_KEY.test(key) ? FILTERED : scrubValue(entry)])
    )
}

export function scrubSecrets<T>(event: T): T {
    return scrubValue(event) as T
}
